import React from "react";
import CreateHosting from "../../components/hosting/createHosting/CreateHosting";
import HostingComponent from "../../components/hosting/Hosting";
const Hosting = () => {
  return (
    <>
      <HostingComponent />
      <CreateHosting />
    </>
  );
};

export default Hosting;
